<template>
  <BasePage title="Signup">
    <AuthContainer>
      <section class="box mt-4">
        <h1 class="title is-2">Signup</h1>

        <form action="" method="post" @submit.prevent="signup()">
          <div class="field">
            <label class="label">Email</label>
            <p class="control">
              <input
                v-focus
                v-model="email"
                class="input"
                :class="error.email && 'is-danger'"
                type="email"
                placeholder="name@example.com"
                required
                />
            </p>
            <p v-if="error.email" class="text-danger">
              {{ error.message[0] }}
            </p>
          </div>

          <div class="field">
            <label class="label">Password</label>
            <p class="control">
              <input
                v-model="password1"
                class="input"
                :class="errorPassword1 && 'is-danger'"
                type="password"
                placeholder="super secret password"
                required
                />
            </p>
            <p v-if="error.password1.blank" class="text-danger">
              This cannot be blank
            </p>
            <p v-if="error.password1.short" class="text-danger">
              This password is too short
            </p>
            <p v-if="error.password1.common" class="text-danger">
              This password is too common
            </p>
            <p v-if="error.passwords_differ" class="text-danger">
              Passwords differ
            </p>
          </div>

          <div class="field">
            <label class="label">Password Again</label>
            <p class="control">
              <input
                v-model="password2"
                class="input"
                :class="errorPassword2 && 'is-danger'"
                type="password"
                placeholder="super secret password (again)"
                required
                />
            </p>
            <p v-if="error.password2.blank" class="text-danger">
              This cannot be blank
            </p>
            <p v-if="error.password2.short" class="text-danger">
              This password is too short
            </p>
            <p v-if="error.password2.common" class="text-danger">
              This password is too common
            </p>
            <p v-if="error.passwords_differ" class="text-danger">
              Passwords differ
            </p>
          </div>


          <div class="field">
            <p class="control flex-space-between flex-align-center">
              <button class="button is-primary" :class="loading && 'is-loading'">Create Account</button>
              <router-link to='/forgot-password'>Forgot password?</router-link>
            </p>
          </div>

        <div class="d-flex align-items-center mb-2 mt-1">
          <span class="or-bar"></span> or <span class="or-bar"></span>
        </div>
        <!-- <SocialButtons :page="'signup'" :loading="loading"/> -->

          <p class="title-subtext">
            Already have an account? <router-link class="is-3" to="/login">Login →</router-link>
          </p>

        </form>
      </section>
    </AuthContainer>
  </BasePage>
</template>

<script>
import BasePage from './BasePage.vue'
import { focus } from '../directives.js'
import SocialButtons from './SocialButtons'
import AuthContainer from './AuthContainer'

import store from '../store'

const defaultError = {
  email: false,
  message: '',
  password1: {
    blank: false,
    short: false,
    common: false,
  },
  password2: {
    blank: false,
    short: false,
    common: false,
  },
  passwords_differ: false,
}

const isBlank = errorList =>
  errorList != null && errorList.includes('This field may not be blank.')
const isCommon = errorList =>
  errorList != null && errorList.includes('This password is too common.')
const isShort = errorList =>
  errorList != null && errorList.includes('This password is too short. It must contain at least 8 characters.')

const responseErrors = res => ({
  email: res.email != null,
  message: res.email,
  password1: {
    blank: isBlank(res.password1),
    short: isShort(res.password1),
    common: isCommon(res.password1),
  },
  password2: {
    blank: isBlank(res.password2),
    short: isShort(res.password2),
    common: isCommon(res.password2),
  },
  passwords_differ: res.non_field_errors != null,
})

export default {
  name: 'Signup',
  data () {
    return {
      email: '',
      password1: '',
      password2: '',
      error: defaultError,
      loading: false,
    }
  },
  components: {
    BasePage,
    SocialButtons,
    AuthContainer,
  },
  computed: {
    errorPassword1 () {
      return this.error.password1.blank ||
        this.error.password1.short ||
        this.error.password1.common ||
        this.error.passwords_differ
    },
    errorPassword2 () {
      return this.error.password2.blank ||
        this.error.password2.short ||
        this.error.password2.common ||
        this.error.passwords_differ
    },
  },
  methods: {
    async signup () {
      this.error = defaultError
      this.loading = true
      const { email, password1, password2 } = this
      this.loading = true
      try {
        await store.dispatch('signup', { email, password1, password2 })
      } catch (error) {
        this.error = responseErrors(error.response.data)
      }
      this.loading = false
    },
  },
  directives: {
    focus,
  },
}
</script>

<style lang="scss" scoped>

@import '../_variables.scss';

.box {
  box-shadow: 0 2px 6px 0 rgba(0,0,0,.4);
  border-radius: 5px;
}

.container {
    margin: initial;
}

.title {
  margin-bottom: 0.5rem !important;
}

.title-subtext {
  margin-top: 0.5rem !important;
  margin-bottom: 0.5rem !important;
}

</style>



// WEBPACK FOOTER //
// Signup.vue?059632d7